import FormControlLabel from "@mui/material/FormControlLabel";
import Stack from "@mui/material/Stack";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import React from "react";

const ProductAdditionalInfoForm = ({
  additionalInfo,
  setAdditionalInfo,
  isAdditionalEmpty,
}) => {
  const {
    productDescription,
    productBenefits,
    storageAndUsage,
    otherProductInfo,
    productType,
    productSlug,
    isWeightVariable,
  } = additionalInfo;

  return (
    <Stack direction='column' spacing={2}>
      <TextField
        fullWidth
        multiline
        rows={4}
        label='Product Description'
        value={productDescription}
        error={productDescription === "" && isAdditionalEmpty}
        helperText={
          isAdditionalEmpty && productDescription === "" ? "Empty" : null
        }
        id='product_description'
        required
        onChange={(e) => {
          setAdditionalInfo({
            ...additionalInfo,
            productDescription: e.target.value,
          });
        }}
      />
      <TextField
        fullWidth
        multiline
        rows={4}
        label='Product Benefits '
        value={productBenefits}
        error={productBenefits === "" && isAdditionalEmpty}
        helperText={
          isAdditionalEmpty && productBenefits === "" ? "Empty" : null
        }
        id='product_benefits'
        required
        onChange={(e) => {
          setAdditionalInfo({
            ...additionalInfo,
            productBenefits: e.target.value,
          });
        }}
      />
      <TextField
        fullWidth
        multiline
        rows={4}
        label='Storage And Usage'
        value={storageAndUsage}
        error={storageAndUsage === "" && isAdditionalEmpty}
        helperText={
          isAdditionalEmpty && storageAndUsage === "" ? "Empty" : null
        }
        id='storage_and_usage'
        required
        onChange={(e) => {
          setAdditionalInfo({
            ...additionalInfo,
            storageAndUsage: e.target.value,
          });
        }}
      />
      <TextField
        fullWidth
        multiline
        rows={4}
        label='Other Product Info'
        value={otherProductInfo}
        error={otherProductInfo === "" && isAdditionalEmpty}
        helperText={
          isAdditionalEmpty && otherProductInfo === "" ? "Empty" : null
        }
        id='other_product_info'
        required
        onChange={(e) => {
          setAdditionalInfo({
            ...additionalInfo,
            otherProductInfo: e.target.value,
          });
        }}
      />

      <TextField
        fullWidth
        label='Product Type'
        value={productType}
        error={productType === "" && isAdditionalEmpty}
        helperText={isAdditionalEmpty && productType === "" ? "Empty" : null}
        id='product_type'
        required
        onChange={(e) => {
          setAdditionalInfo({
            ...additionalInfo,
            productType: e.target.value,
          });
        }}
      />

      <TextField
        fullWidth
        label='Product Slug'
        value={productSlug}
        error={productSlug === "" && isAdditionalEmpty}
        helperText={isAdditionalEmpty && productSlug === "" ? "Empty" : null}
        id='product_slug'
        required
        onChange={(e) => {
          setAdditionalInfo({
            ...additionalInfo,
            productSlug: e.target.value,
          });
        }}
      />

      <FormControlLabel
        control={
          <Checkbox
            color='info'
            checked={isWeightVariable}
            onChange={(e) => {
              setAdditionalInfo({
                ...additionalInfo,
                isWeightVariable: e.target.checked,
              });
            }}
          />
        }
        label='Is Weight Variable'
      />
    </Stack>
  );
};

export default ProductAdditionalInfoForm;
